

function selectedImage(state= {}, action) {
    return state
}

export default selectedImage



// WEBPACK FOOTER //
// ./src/reducers/selectedImage.js